export default __webpack_public_path__ + "static/egg-shell-a1ddc5f5295429dcc5a7bf4f4f0ba1a7.png";